import { useMemo } from 'react';
import versionData from '../version.json';

interface VersionInfo {
  version: string;
  gitSha: string;
  buildTime: string;
  shortVersion: string;
  displayVersion: string;
}

export function useVersion(): VersionInfo {
  return useMemo(() => ({
    version: versionData.version,
    gitSha: versionData.gitSha,
    buildTime: versionData.buildTime,
    shortVersion: versionData.shortVersion,
    displayVersion: versionData.displayVersion,
  }), []);
}
